<template>
    <loading v-if="isLoading" />
    <v-form v-else class="form" v-model="isValid">
        <v-container>
            <h1 class="display-1 text-center base-header font pa-8">
                Select your sheet
            </h1>
            <v-container class="fill-height" fluid>
                <v-row align="center" justify="center">
                    <v-col cols="12" sm="8" md="4">
                        <v-card class="elevation-12 rounded select-sheet-card mt-n6">
                            <v-col>
                                <v-select2 v-model="selectedSheet" :options="sheetsValues" placeholder="Select your sheet"></v-select2>
                            </v-col>
                            <v-col align="center" justify="center">
                                <v-btn class="mb-4" width="100%" color="secondary" :disabled="!isValid" @click="postDefaultSheet()">
                                    Select
                                </v-btn>
                            </v-col>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-container>
    </v-form>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import Loading from '@/components/layouts/Loading.vue';
    export default {
        components: {
            Loading,
        },
        data() {
            return {
                isValid: false,
                selectedSheet: null,
                sheetsValues: [],
            };
        },

        computed: {
            ...mapGetters({
                sheets: ['getSheets'],
                isLoading: ['getIsLoading'],
            }),
        },

        methods: {
            async getSheets() {
                await this.fetchSheets().then(() => {
                    this.sheetsValues = Object.values(this.sheets);
                });
            },

            ...mapActions(['form/', 'fetchSheets']),
            ...mapActions(['selectsheet/', 'postSelectedSheet']),

            postDefaultSheet() {
                this.postSelectedSheet({ sheet_name: this.selectedSheet }).then(() => {
                    this.$router.push({
                        name: 'LoginPage',
                    });
                });
            },
        },

        mounted() {
            this.getSheets();
        },
    };
</script>

<style scoped>
    .base-header {
        font-family: Bariol !important;
        font-style: normal;
        font-weight: bold;
        letter-spacing: 0.5px !important;
    }

    .select-sheet-card {
        background: #ffffff !important ;
        box-shadow: 2px 1px 10px rgba(205, 205, 212, 0.1) !important;
        border-radius: 20px !important;
        filter: drop-shadow(2px 1px 10px rgba(162, 162, 162, 0.25));
    }
</style>
